<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.riesgos.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item.$model" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_campo.codigo"
                            :validator="item"
                            v-model="item.$model.riesgo.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtons';
import riesgoRevictimizacionService from '../../../../services/riesgoRevictimizacionService';
import riesgoRevictimizacionUsuarioService from '../../../../services/riesgoRevictimizacionUsuarioService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from '../../../../components/common/utilities/toast';
export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            riesgos: []
        }
    },
    validations(){
        return {
            riesgos:{
                $each:{
                    riesgo:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let riesgos_usuario = [];

                this.riesgos.forEach((x) => {
                    if (x.riesgo.valor !== "") {
                        riesgos_usuario.push({ ...x.riesgo });
                    }
                });

                this.LoaderSpinnerShow();
                await riesgoRevictimizacionUsuarioService.store({
                    riesgos_usuario: riesgos_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error);
                Toast.fire({
                    icon: 'error',
                    title: 'Ha ocurrido un error al procesar la solicitud'
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await riesgoRevictimizacionService.index({
            params: filter
        });

        const riesgos_usuario = await riesgoRevictimizacionUsuarioService.index(
            this.idHistoria
        ); 

        this.riesgos = response.data.map((y) => {
            const indice = riesgos_usuario.data.findIndex(
                (a) => a.id_riesgo === y.id
            );
            y.riesgo = {
                id: indice !== -1 ? riesgos_usuario.data[indice].id : 0,
                id_usuario: this.usuario.id,
                id_historia:this.idHistoria,
                id_riesgo: y.id,
                valor: indice !== -1 ? riesgos_usuario.data[indice].valor : "",
            };
            return y;
        }); 
    }

}
</script>